import { createContext, useContext } from 'react';
import invariant from 'tiny-invariant';
/**
 * Context used to share the `onClose` prop value with sub-components.
 */
export var OnCloseContext = /*#__PURE__*/createContext(undefined);
export var useOnClose = function useOnClose() {
  return useContext(OnCloseContext);
};

/**
 * Used to ensure Drawer sub-components are used within a Drawer component,
 * and provide a useful error message if not.
 */
export var EnsureIsInsideDrawerContext = /*#__PURE__*/createContext(false);
export var useEnsureIsInsideDrawer = function useEnsureIsInsideDrawer() {
  var context = useContext(EnsureIsInsideDrawerContext);
  invariant(context, 'Drawer sub-components must be used within a Drawer component.');
};